import React from "react";
import Header from '../Component/Header';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AdminService from "../Services/AdminService";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";

const ManageCompanyProfile = () => {
    const token = localStorage.getItem("JWTToken");
    const { uniqueKey } = useParams();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("About Company");
    const [CompanyName, SetCompanyName] = useState();
    const [State, SetState] = useState();
    const [Country, SetCountry] = useState();
    const [City, SetCity] = useState();
    const [PostalCode, SetPostalCode] = useState();
    const [Address, SetAddress] = useState();
    const [CompanyLogo, SetCompanyLogo] = useState();
    const [ContactMail, SetContactMail] = useState();
    const [ContactNumber, SetContactNumber] = useState();
    const [WebsiteURL, SetWebsiteURL] = useState();
    const [ParentCompany, SetParentCompany] = useState();
    const [Subsidiaries, SetSubsidiaries] = useState();
    const [EstablishmentDate, SetEstablishmentDate] = useState();
    const [EstablishmentTime, SetEstablishmentTime] = useState();
    const [ResetBasicData, SetResetBasicData] = useState(false);
    const [IsAdmin, SetIsAdmin] = useState(false);
    const [errors, setErrors] = useState({});
    const location = useLocation();
    const [CompanyUsers, setCompanyUsers] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const UserRoleID = localStorage.getItem("RoleID");
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [mobile, setMobile] = useState("");
    const [MobileError, settMobileError] = useState("");
    const [email, setEmail] = useState("");
    const [Emailerror, setEmailError] = useState("");
    const [name, setName] = useState("");

    const [nameError, setNameError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [roleError, setRoleError] = useState("");

    useEffect(() => {
        if (location.state?.defaultTab) {
            setActiveTab(location.state.defaultTab);
        }
    }, [location.state]);

    useEffect(() => {
        if (token) {
            const fetchData = async () => {
                try {
                    const CompanyResponse = await AdminService.GetCompanyUsers(token);
                    if (CompanyResponse && CompanyResponse.RESPONSE) {
                        setCompanyUsers(CompanyResponse.RESPONSE);
                        console.log(CompanyResponse.RESPONSE)
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };

            fetchData();
        } else {
            navigate("/Login");
        }
    }, [token, navigate]);

    useEffect(() => {
        if (token) {
            const GetCompaniyDetailsForAdmin = async () => {
                const response = await AdminService.GetCompaniyDetailsForAdmin(token, uniqueKey);
                if (response) {
                    const companyDetails = response.Company_Details;
                    SetCompanyLogo(companyDetails[0].CompanyLogo);
                    SetCompanyName(companyDetails[0].CompanyName);
                    SetAddress(companyDetails[0].CompanyAddress);
                    SetCountry(companyDetails[0].Country);
                    SetState(companyDetails[0].State);
                    SetPostalCode(companyDetails[0].PostalCode);
                    SetCity(companyDetails[0].City);
                    SetContactMail(companyDetails[0].ContactMail);
                    SetContactNumber(companyDetails[0].ContactNumber);
                    SetWebsiteURL(companyDetails[0].WebsiteURL);
                    SetIsAdmin(companyDetails[0].IsAdmin);
                    console.log(companyDetails[0].IsAdmin);
                    console.log(companyDetails);
                    SetParentCompany(companyDetails[0].ParentCompany);
                    SetSubsidiaries(companyDetails[0].Subsidiaries);
                    SetResetBasicData(false);
                    debugger;
                    if (companyDetails[0].EstablishmentDate) {
                        const startDateTime = parseDateString(companyDetails[0].EstablishmentDate);
                        if (startDateTime) {
                            SetEstablishmentDate(formatDate(startDateTime));
                        } else {
                            console.error("Invalid date format, unable to parse.");
                        }
                    }
                }
            }
            GetCompaniyDetailsForAdmin();
        } else {
            navigate("/Login");
        }
    }, [token, ResetBasicData]);
    const handleSearchChange = (e) => setSearchQuery(e.target.value.toLowerCase());

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    }
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because getMonth() is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const parseDateString = (dateString) => {
        const parsedDate = new Date(dateString); // Convert to Date object
        if (isNaN(parsedDate)) {
            console.error(`Invalid date string: ${dateString}`);
            return null; // Return null if invalid
        }
        return parsedDate;
    };
    const validate = () => {
        let errors = {};
        debugger;
        if (!CompanyName?.trim()) errors.CompanyName = "Company name is required";
        if (!ContactMail?.trim()) {
            errors.ContactMail = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(ContactMail)) {
            errors.ContactMail = "Invalid email format";
        }
        if (!ContactNumber?.trim()) {
            errors.ContactNumber = "Phone number is required";
        } else if (!/^\d{10}$/.test(ContactNumber)) {
            errors.ContactNumber = "Phone number must be 10 digits";
        }
        if (!Address?.trim()) errors.Address = "Address is required";
        if (!City?.trim()) errors.City = "City is required";
        if (!State?.trim()) errors.State = "State is required";
        if (!Country?.trim()) errors.Country = "Country is required";
        if (!PostalCode?.trim()) {
            errors.PostalCode = "Postal code is required";
        } else if (!/^\d{5,6}$/.test(PostalCode)) {
            errors.PostalCode = "Invalid postal code";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSaveBasicDetails = () => {
        if (validate()) {
            const SubmitformData = new FormData();
            SubmitformData.append('Token', token);
            SubmitformData.append('CompanyUID', uniqueKey);
            SubmitformData.append('CompanyLogo', CompanyLogo);
            SubmitformData.append('CompanyName', CompanyName);
            SubmitformData.append('Country', Country);
            SubmitformData.append('City', City);
            SubmitformData.append('CompanyAddress', Address);
            SubmitformData.append('State', State);
            SubmitformData.append('PostalCode', PostalCode);
            SubmitformData.append('ContactMail', ContactMail);
            SubmitformData.append('ContactNumber', ContactNumber);
            SubmitformData.append('WebsiteURL', WebsiteURL);
            SubmitformData.append('ParentCompany', ParentCompany);
            SubmitformData.append('Subsidiaries', Subsidiaries);
            try {
                const UpdateCompanydata = async () => {
                    const response = await AdminService.UpdateCompanyData(SubmitformData);
                    if (response) {
                        alert(response.MESSAGE);
                    }
                }
                UpdateCompanydata();
            } catch (error) {
                console.error(error);
            }
        }
    };
    const handleFileupload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
            if (!validTypes.includes(file.type)) {
                alert('Invalid file type. Please upload an image (JPG, PNG, GIF, BMP).');
                return;
            }

            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
                alert('File is too large. Maximum size is 5MB.');
                return;
            }

            SetCompanyLogo(file);
        }
    }
    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
            if (!validTypes.includes(file.type)) {
                alert('Invalid file type. Please upload an image (JPG, PNG, GIF, BMP).');
                return;
            }
            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
                alert('File is too large. Maximum size is 5MB.');
                return;
            }
            SetCompanyLogo(file);
        }
    };
    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleDragLeave = (event) => {
        event.preventDefault();
    };
    const filteredCompanyUsers = CompanyUsers.filter((plan) =>
        Object.values(plan).some(
            (value) =>
                typeof value === "string" && value.toLowerCase().includes(searchQuery)
        )
    );
    const handleroleChange = (event) => {
        const selectedRoleId = event.target.value;
        setSelectedRole(selectedRoleId);
        setSelectedRole(event.target.value);
        setRoleError(event.target.value ? "" : "Role selection is required.");
    };
    const handleMobileChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setMobile(value);
            if (value.length === 10) {
                if (!/^[6789]\d{9}$/.test(value)) {
                    settMobileError("Mobile number must start with 6, 7, 8, or 9.");
                } else {
                    settMobileError("");
                }
            } else {
                settMobileError("Mobile number must be exactly 10 digits.");
            }
        }
    };
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!value) {
            setEmailError("Email is required.");
        } else if (!emailPattern.test(value)) {
            setEmailError("Please enter a valid email address.");
        } else {
            setEmailError("");
        }
    };
    const handleNameChange = (e) => {
        setName(e.target.value);
        setNameError(e.target.value ? "" : "Name is required.");
    };
    const handleSendInvite = () => {
        if (!name) setNameError("Name is required.");
        if (!email) setEmailError("Email is required.");
        if (!mobile) setMobileError("Mobile number is required.");
        if (!selectedRole) setRoleError("Role selection is required.");

        if (name && Emailerror === "" && mobileError === "" && selectedRole) {
            const CreateUsers = async () => {
                const response = await AdminService.CreateUsers(token, name, email, mobile, selectedRole);
                if (response) {
                    if (response.STATUS === "SUCCESS"){
                        alert(response.MESSAGE);
                    }
                    else{
                        console.log(response.RESPONSE);
                        alert(response.MESSAGE);
                    }
                }
            }
            CreateUsers();
        }
    };

    useEffect(() => {
        try {
            const GetRoles = async () => {
                const response = await AdminService.GetRoles(token);
                if (response) {
                    if (response.STATUS === "SUCCESS") {
                        setRoles(response.RESPONSE);
                        console.log(response.RESPONSE);
                    }
                }
            }
            GetRoles();
        } catch (error) {
            console.error(error)
        }
    }, [token, UserRoleID, navigate]);

    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const renderTabContent = () => {
        switch (activeTab) {
            case "About Company":
                return (<>
                    <div className="mt-5 nav-tabs">
                        <div className="row mb-4">
                            <div className="col-4">
                                <h4 className="TruveyColor fw-bold">Logo</h4>
                            </div>
                            <div className="col-5 d-flex align-items-center gap-3 ">
                                <div className="CompanyLogoSet p-1">
                                    <div className="CompanyLogoSet">
                                        {CompanyLogo && typeof CompanyLogo === "object" ? (
                                            <img
                                                src={URL.createObjectURL(CompanyLogo)}
                                                alt="Company Logo"
                                                className="w-100 h-100"
                                            />
                                        ) : (
                                            <img src={CompanyLogo} alt="Company Logo..." className="w-100 h-100" />
                                        )}
                                    </div>
                                    <div className="d-none">
                                        <input type="file" name="CompanyLogo" id="CompanyLogo" accept=".jpg, .gif, .png, .bmp" onChange={handleFileupload} />
                                    </div>
                                </div>
                                <div className="" onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}>
                                    <label htmlFor="CompanyLogo" className="cursor border-dashed p-3">
                                        {
                                            CompanyLogo && typeof CompanyLogo === "string" && CompanyLogo.includes("https://api.xprssurvey.com")
                                                ? null
                                                : (
                                                    <>
                                                        <p className="text-center mb-0 fs-12">
                                                            {CompanyLogo && typeof CompanyLogo === "object" && CompanyLogo.name}
                                                        </p>
                                                    </>
                                                )
                                        }
                                        Drag and drop your logo here or <br /> <b> Browser</b> to choose a file
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <h4 className="TruveyColor fw-bold">Basic info</h4>
                            </div>
                            <div className="col-6">
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Company Name</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={CompanyName || ""} onChange={(e) => SetCompanyName(e.target.value)} />
                                        {errors.CompanyName && <span className="text-danger fs-12">{errors.CompanyName}</span>}

                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Contact Person Mail</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={ContactMail || ""} onChange={(e) => SetContactMail(e.target.value)} />
                                        {errors.ContactMail && <span className="text-danger fs-12">{errors.ContactMail}</span>}

                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Contact Person Mobile </label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={ContactNumber || ""} onChange={(e) => SetContactNumber(e.target.value)} />
                                        {errors.ContactNumber && <span className="text-danger fs-12">{errors.ContactNumber}</span>}

                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Address</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={Address ? Address : ""} onChange={(e) => SetAddress(e.target.value)} />
                                        {errors.Address && <span className="text-danger fs-12">{errors.Address}</span>}

                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">City</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={City ? City : ""} onChange={(e) => SetCity(e.target.value)} />
                                        {errors.City && <span className="text-danger fs-12">{errors.City}</span>}

                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Country</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={Country ? Country : ""} onChange={(e) => SetCountry(e.target.value)} />
                                        {errors.Country && <span className="text-danger fs-12">{errors.Country}</span>}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">State</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={State ? State : ""} onChange={(e) => SetState(e.target.value)} />
                                        {errors.State && <span className="text-danger fs-12">{errors.State}</span>}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Postal Code</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={PostalCode ? PostalCode : ""} onChange={(e) => SetPostalCode(e.target.value)} />
                                        {errors.PostalCode && <span className="text-danger fs-12">{errors.PostalCode}</span>}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Parent Company</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={ParentCompany} onChange={(e) => SetParentCompany(e.target.value)} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Subsidiaries</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={Subsidiaries} onChange={(e) => SetSubsidiaries(e.target.value)} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Establishment Date</label></div>
                                    <div className="col-7">
                                        <input type="date" className="nav-link p-2 fs-14 br-none border  text-black w-100 bg-grey2" name="startDate" value={EstablishmentDate} onChange={(e) => SetEstablishmentDate(e.target.value)} readOnly={true} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">WebsiteURL</label></div>
                                    <div className="col-7">
                                        <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" onChange={(e) => SetWebsiteURL(e.target.value)} value={WebsiteURL} />
                                        {errors.WebsiteURL && <span className="text-danger fs-12">{errors.websiteURL}</span>}
                                    </div>
                                </div>

                                <div className="my-4 pe-5 text-end">
                                    <button className="btn text-danger me-3" onClick={(e) => { SetResetBasicData(true) }}>Discard changes</button>
                                    <button className="Gold br-5 px-4 border-0" onClick={handleSaveBasicDetails}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </>);
            case "Members":
                return (<>
                    <div className="min-hight85vh">
                        <div className="bg-grey">
                            <div className="container pt-4">
                                <h4 className="TruveyColor fw-bold">Company Members</h4>
                                <div className="d-flex justify-content-between align-items-center my-4">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control w-25"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <button className="Gold br-5 px-3 border-0" onClick={handleOpen}>
                                        <i className="fas fa-plus"></i> Invite Member
                                    </button>
                                </div>
                            </div>
                        </div>
                        {filteredCompanyUsers.length > 0 ? (
                            <div className="overflow-auto">
                                <div className="min-Width1100px">
                                    <table className="table">
                                        <thead className="bg-grey fs-14">
                                            <tr>
                                                <th className="fw-6 bg-grey3 text-center">Name</th>
                                                <th className="fw-6 bg-grey3">Member Role</th>
                                                <th className="fw-6 bg-grey3">Gender</th>
                                                <th className="fw-6 bg-grey3">Last Login</th>
                                                <th className="fw-6 bg-grey3">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-4 fs-14">
                                            {filteredCompanyUsers.map((user, index) => (
                                                <tr key={index} className="border-0">
                                                    <td className="bg-grey py-3 border-0">
                                                        <div className="d-flex gap-1 align-items-start">
                                                            <div className="col-3">
                                                                <img
                                                                    src={user.ProfileImageUrl || "default-profile.png"}
                                                                    className="PlanLogoSet"
                                                                    alt="User Profile"
                                                                    style={{ borderRadius: "50%" }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <div className="fw-bold fs-6">{user.Name || "N/A"}</div>
                                                                <div>{user.Email || "N/A"}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="bg-grey py-3 border-0">{user.RoleName || "N/A"}</td>
                                                    <td className="bg-grey py-3 border-0">{user.Gender || "N/A"}</td>
                                                    <td className="bg-grey py-3 border-0">{user.LastLogin || "N/A"}</td>
                                                    <td className="bg-grey py-3 border-0">
                                                        {user.Status === true ? (
                                                            "Active"
                                                        ) : user.Status === false ? (
                                                            "Inactive"
                                                        ) : (
                                                            <span className="badge bg-danger text-white p-2">Pending Invite</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <p>No members available.</p>
                        )}
                        <Modal open={open} onClose={handleClose}>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    bgcolor: 'background.paper',
                                    borderRadius: 2,
                                    boxShadow: 24,
                                    p: 4,
                                    width: 600,
                                }}
                            >
                                <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                    Invite Member
                                </h4>
                                <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input type="text" className="form-control" placeholder="Enter name" value={name} onChange={handleNameChange} />
                                    {nameError && <small className="text-danger">{nameError}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input type="email" className="form-control" placeholder="Enter email" value={email} onChange={handleEmailChange} /> 
                                    {Emailerror && <small className="text-danger">{Emailerror}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Mobile No</label>
                                    <input type="text" className="form-control" placeholder="Enter mobile no" value={mobile} onChange={handleMobileChange} maxLength="10" />
                                    {MobileError && <small className="text-danger">{MobileError}</small>}
                                    {mobileError && <small className="text-danger">{mobileError}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Role</label>
                                    <select className="Sanket-Control nav-link mt-2 fs-14 p-2" value={selectedRole} onChange={handleroleChange}>
                                        <option value="">Select a role</option>
                                        {
                                            roles.map((data) =>
                                            (
                                                <>
                                                    <option key={data.RoleID} value={data.RoleID}>{data.RoleName}</option>
                                                </>
                                            )
                                            )
                                        }
                                    </select>
                                    {roleError && <small className="text-danger">{roleError}</small>}
                                </div>
                                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                    <button className="text-dark ActionBtns" onClick={handleClose}>
                                        Close
                                    </button>
                                    <button className={`py-1 px-4 border-0 Gold br-5`} onClick={handleSendInvite}> 
                                        Send Invite
                                    </button>
                                </Box>
                            </Box>
                        </Modal>
                    </div>
                </>);
            case "Billing And Invoices":
                return <div className="mt-5 text-center"><h5 className="text-muted">Billing and Invoices Section</h5></div>;
            case "Surveys":
                return <div className="mt-5 text-center"><h5 className="text-muted">Surveys Section</h5></div>;
            default:
                return <div className="mt-5 text-center"><h5 className="text-muted">Select a tab</h5></div>;
        }
    }
    return (<>
        <Header />
        <div className="min-hight75vh bg-grey">
            <div className="py-5 container">
                <h4 className="fw-bold">Account and Settings</h4>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="nav nav-tabs">
                        {[
                            "About Company",
                            ...(IsAdmin ? ["Members"] : []),
                            "Billing And Invoices",
                            ...(IsAdmin ? ["Surveys"] : [])
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`nav-link bg-grey ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleTabChange(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>
                {renderTabContent()}
            </div>
        </div>
    </>)
}
export default ManageCompanyProfile;